<div
  class="footer vw-100 h-50 d-flex justify-space-between align-flex-end plr-30"
>
  <button class="footer-cancel h-34 ui-btn ui-btn--secondary" (click)="closeModalEvent.emit()">
    Cancelar
  </button>
  <button class="footer-success h-34 ui-btn ui-btn--primary" (click)="addContractsEvent.emit()">
    Adicionar Contratos
  </button>
</div>
